<template>
  <b-container fluid class="mt-3 text-center">
    <b-form>
    <div class="row justify-content-md-center">
      <div class="col-sm-9">
        <div>
          <b-card style="background-color: #172546" border-variant="light">
            <img src="../assets/logo_clikautomobility.png" class="img-fluid imagen_autocom m-4" alt="" />
        </b-card>

        </div>
        <div >
          <b-card class="text-center" border-variant="light">
            <h2 >¡Tenemos tus resultados!</h2>
            <br>
            <h5>Tienes una suscripción pendiente, continúa desde un dispositivo móvil</h5>
          </b-card>
        </div>
        <div>
          <b-card class="text-center" bg-variant="light" border-variant="light">
            <b-row>
              <div class="col-md-3">
                <b-col>
                  Vigencia Suscripción.
                  <h3 style="color: #172546; font-size: 20px;">{{this.FechaV}}</h3>
                </b-col>
              </div>
              <div class="col-md-3">
                <b-col>
                    Depósito Suscripción
                  <h3 style="color: #172546; font-size: 20px;">${{formatPrice(this.deposito)}}</h3>
                </b-col>
              </div>
              <div class="col-md-3">
                <b-col>
                  Costo Suscripción
                  <h3 style="color: #172546; font-size: 20px;">${{this.costoSus}}</h3>
                </b-col>
              </div>
              <div class="col-md-3">
                <b-col>
                  Total a Pagar
                  <h3 style="color: #172546; font-size: 20px;">${{this.valorTotal}}</h3>
                </b-col>
              </div>
            </b-row>
            <b-row>
              <div v-for="auto in autos" :key="auto.id" class="col-md-12">
                <b-col>
                  Vehículo.
                  <h3 style="color: #172546; font-size: 20px;">
                    {{ auto.modelYear }} {{ auto.brandDescription }} {{ auto.trimDescription }}, {{ auto.bodyType }} {{ auto.gearboxType }}, {{ auto.doors}} PUERTAS
                  </h3>
                </b-col>
              </div>
            </b-row>
          </b-card>
        </div>
        <div>
          <b-card class="text-center" border-variant="light">
            <b-row class="justify-content-md-center">
                <p>¡ Termina ahora tu solicitud !</p>
                <b-button class="button_sc" @click.prevent="validarDispositivo()">SOLICITAR SUSCRIPCION</b-button>
            </b-row>
          <!-- <b-button class="m-3" @click.prevent="mail()" variant="danger" >Mail</b-button> -->
          </b-card>
        </div>
          <b-modal ref="modalNoContinuar"  size="sm" hide-footer>
            <template #modal-title>
              <h5 >Continuar Solicitud</h5>
            </template>
              <div class="d-block"><h6>Tu solicitud debe continuar desde un dispositivo móvil</h6></div>
              <b-button @click.prevent="salir()" block class="button_movil mb-2 mt-4">¡CONTINUAR!</b-button>
          </b-modal>
      </div>
    </div>
    </b-form>
  </b-container>
</template>

<script>
export default {
    name:"Correo",

    data() {
      return {
          dealer:'',
          FechaV: sessionStorage.getItem("fechaVigencia"),
          autos: [],
          costoSus: sessionStorage.getItem("valorTotal"),
          valorTotal: sessionStorage.getItem("valorSuscripcion"),
          deposito: 2400,
          vin: sessionStorage.getItem("vinUnidad"),
          type: sessionStorage.getItem("typeUnidad"),
      }
    },

    methods: {

    cargarInfoVehiculo(){

        if( this.type == 'U'){
            this.autosSeminuevos();
        } else if( this.type == 'N'){
            this.autosNuevos();
        }
      },

        autosNuevos(){
                  //axios.get("https://pruebas.autocomcube.mx/ab/api/newstock", { //QA
                  axios.get("https://autocomcube.mx/ab/api/newstock", { //PRO        
                  headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                    'Content-Type': 'application/json',
                  },
                  params: {vin: this.vin},
                }).then((response) => {
                  this.autos = response.data.newstock;
                });      
        },

        autosSeminuevos(){
            // console.log('Seminuevo');
                  axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
                  //axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
                  headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                    'Content-Type': 'application/json',
                  },
                  params: {vin: this.vin,},
                }).then((response) => {
                  this.dealer = response.data.usedstock[0].dealerShip;
                  this.autos = response.data.usedstock;
                }).catch(error => {
              console.log(error);
            });
        },

        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        salir(){
          localStorage.clear();
          window.history.go(-3);
        },
        validarDispositivo(){
                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                  //window.open("https://onboarding-prod.latinid-cloud.com.mx/autocom/#/welcome?data="+this.getUrlUuid());
                  window.open("https://onboarding-dev.latinid-cloud.com.mx/MobilityWeb/#/resume/applicant/"+sessionStorage.getItem("UUID58"));
                  window.history.go(-3);
                  sessionStorage.removeItem('SolicitanteID');
          } else {
                this.$refs['modalNoContinuar'].show();
            }
        },
    },

  created() {
    this.cargarInfoVehiculo();
   },
}

</script>

<style>
.imagen_autocom {
  height:auto;
}

.input_c{
     border: 1px solid #FDFEFE;
     width: 10px;
     height: 10px;
}


@media only screen and (max-width: 1028px){
  .imagen_autocom {
     width: 150px;
 }

}
</style>